module.exports = __webpack_public_path__ + "media/img/iryo/inicial-12f5f77e928244a70f914275cb75d69a.png";